var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('img',{staticClass:"mb-5",attrs:{"src":"/v.png","alt":"Vuetify.js"}}),_c('blockquote',{staticClass:"blockquote"},[_c('footer')])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }